import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';

import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';

import { Message, MessagesListType } from '@biorec/partners/domain';
import { MessagesServiceGql } from '../';
import { AsyncPipe } from '@angular/common';

@Component({
	standalone: true,
	selector: 'br-messages-list',
	templateUrl: './messages-list.component.html',
	styleUrls: ['./messages-list.component.css'],
	imports: [AsyncPipe, ButtonModule, AccordionModule],
})
export class MessagesListComponent implements OnInit {
	@Input()
	type: MessagesListType;

	protected $messages: Observable<Message[]>;
	protected isViewed: any = {};
	protected selectedMsgId: number;

	constructor(
		private svc: MessagesServiceGql,
		private route: ActivatedRoute
	) {}

	ngOnInit() {
		this.route.params.subscribe((params) => {
			this.selectedMsgId = params.id;

			if (this.selectedMsgId) {
				this.setIsViewed(this.selectedMsgId);
			}
		});
		this.loadData();
	}

	private loadData(): void {
		this.svc
			.getMessagesList(this.type)
			.subscribe((data) => (this.$messages = of(data)));
	}

	protected setIsViewed(id: number) {
		this.isViewed[id] = true;
		this.svc.updateMessage(
			{ msgId: id, open: true, read: false },
			this.type
		);
	}

	protected deleteMessage(data: { originalEvent: Event; id: number }) {
		data.originalEvent.stopPropagation();
		this.svc.updateMessage(
			{ msgId: data.id, open: false, read: true },
			this.type
		);
	}
}
